import { SITE_URL, HERO_IMAGE, AREA_CITIES, BRAND_NAME, LEGAL_NAME, TAGLINE } from "./data";

const areaServed = AREA_CITIES.map((name) => ({ "@type": "City", name }));

const business = {
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: BRAND_NAME,
  legalName: LEGAL_NAME,
  slogan: TAGLINE,
  telephone: "+1-226-626-3220",
  url: `${SITE_URL}/`,
};

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  ...business,
  logo: `${SITE_URL}/brand/icon-512.png`,
  image: HERO_IMAGE,
  description: "Modern business technology in Chatham-Kent, Ontario: IT and computers, Microsoft 365 and cloud, networking and Wi-Fi, business phones and VoIP, security cameras and advertisement TVs.",
  areaServed,
});

export const serviceSchema = (service, content) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: service.title,
  serviceType: service.title,
  description: content.metaDescription,
  url: `${SITE_URL}/services/${service.slug}`,
  image: service.image,
  provider: business,
  areaServed,
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const breadcrumbList = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${path}` })),
});

export const breadcrumbSchema = (service) =>
  breadcrumbList([["Home", "/"], ["Services", "/#services"], [service.title, `/services/${service.slug}`]]);

const townPlace = (name, inChathamKent = true) => ({
  "@type": "City",
  name,
  containedInPlace: inChathamKent
    ? { "@type": "AdministrativeArea", name: "Chatham-Kent", containedInPlace: { "@type": "State", name: "Ontario" } }
    : { "@type": "State", name: "Ontario" },
});

export const areaServiceSchema = (town) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: `Business Technology Services in ${town.name}`,
  serviceType: "Business technology services",
  description: town.metaDescription,
  url: `${SITE_URL}/areas/${town.slug}`,
  provider: business,
  areaServed: townPlace(town.name, town.inChathamKent !== false),
});

export const areasHubSchema = (towns) => ({
  "@context": "https://schema.org",
  ...business,
  areaServed: [{ "@type": "AdministrativeArea", name: "Chatham-Kent" }, ...towns.map((t) => townPlace(t.name, t.inChathamKent !== false))],
});
